<div class="alert-stack" aria-live="polite" aria-atomic="true">
  @for (alert of alerts; track alert.alertId) {
    <div class="alert-card {{ alert.class }} animated {{ alert.animation }}">
      <div class="alert-card__content">
        <div class="alert-card__icon" aria-hidden="true">
          <i class="{{ alert.icon }}"></i>
        </div>

        <div class="alert-card__message">
          @if (getAlertParts(alert.description); as parts) {
            @if (parts.title) {
              <span class="alert-card__title">{{ parts.title }}</span>
            }
            <span class="alert-card__text">{{ parts.message }}</span>
          }
        </div>

        <button
          type="button"
          class="alert-card__close"
          aria-label="Close"
          (click)="dismiss(alert); $event.stopPropagation()"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }
</div>
